import config from '../config'

const ga = ({ page } = {}) => {
  if (!__SERVER__ && config.gaTrackingCode) {
    const ReactGA = require('react-ga4').default

    ReactGA.initialize([
      {
        trackingId: config.gaTrackingCode,
        gaOptions: {
          isProduction: config.isProduction,
          host: config.host,
          apiURL: config.apiURL
        }
      }])
    console.log('GA started')
    if (page) {
      ReactGA.send(page)
    }
  }
}

export default ga
